import React, { useEffect, useRef, useState } from "react";
import NavigationDrawer from "./../../components/navigationDrawer/index";
import CustomBar from "../../components/customBar";
import AppContainer from "../../components/containers/AppContainer";
import TextInput from "../../components/textInput";
import {
  Box,
  Button,
  Divider,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material";
import { APP_ICONS } from "../../assets";
import SelectInput from "../../components/select";
import DynamicTable from "../../components/dynamicTable";
import TableData from "../../Data/vendor.json";
import {
  createVendor,
  fetchAllVendors,
  sendOtp,
  updateVendorStatus,
} from "../../services/Vendor";
import { constants } from "../../theme/Variables";
import Loader from "../../components/loader";
import { CSVLink } from "react-csv";
import CreateVendorModal from "./CreateVendor";
import OTPModal from "./OTPModal";

const selectInputWith = {
  width: { xs: "100%", sm: "150px" },
};

const tableHeader = [
  "VENDOR #ID",
  "VENDOR NAME",
  "PHONE",
  "Bb's Share",
  "Customer's Share",
  "Vendor's Share",
  "JOINED ON",
  "STATUS",
  "ACTION",
];

const displayRows = [
  "user_id",
  "user_data",
  "phone",
  "bbShare",
  "customerShare",
  "vendorShare",
  "created_at",
  "vendor_status",
  "actions",
];
const headersForCsv = [
  { label: "Vendor #ID", key: "_id" },
  { label: "Vendor NAME", key: "name" },
  { label: "EMAIL", key: "email" },
  { label: "Bb's Share", key: "bbShare" },
  { label: "Vendor's Share", key: "vendorShare" },
  { label: "Customer's Share", key: "customerShare" },
  { label: "PHONE", key: "phoneNumber" },
  { label: "JOINED ON", key: "createdAt" },
  { label: "STATUS", key: "status" },
];

const VendorsPage = () => {
  const vendorModalRef = useRef();
  const codeModalRef = useRef();
  const [filterByStatus, setFilterByStatus] = useState("All");
  const [searchValue, setSearchValue] = useState("");
  const [allVendors, setAllVendors] = useState([]);
  const [filteredVendor, setFilteredVendor] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    handleFetchAllVendors();
  }, []);

  useEffect(() => {
    filterAndSearchUsers();
  }, [filterByStatus, searchValue, allVendors]);

  const handleOpenSnackBar = (type, message) => {
    constants.snackRef.isOpenSnack({
      snackType: type,
      snackMessage: message,
    });
  };

  const handleFetchAllVendors = async () => {
    try {
      setIsLoading(true);
      const response = await fetchAllVendors();
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        let data = response?.data?.data;
        setAllVendors(data);
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      handleOpenSnackBar("error", error.data.message);
      console.log(error, "errorerrorerrorerror");
      setIsLoading(false);
    }
  };

  const handleUpdateStatus = async (item, status) => {
    try {
      setIsLoading(true);
      const response = await updateVendorStatus(item?._id, {
        status: status,
      });
      setIsLoading(false);
      if (response.status == 200 || response.status == 201) {
        handleOpenSnackBar("success", response.data.message);
        handleFetchAllVendors();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      handleOpenSnackBar("error", error.data.message);
      console.log(error, "errorerrorerrorerror");
    }
  };

  const filterAndSearchUsers = () => {
    let filteredData = [...allVendors];

    if (filterByStatus !== "All") {
      filteredData = filteredData.filter(
        (vendor) => vendor.status === filterByStatus
      );
    }

    if (searchValue.trim()) {
      filteredData = filteredData.filter(
        (vendor) =>
          vendor?.name?.toLowerCase().includes(searchValue.toLowerCase()) ||
          vendor.email?.toLowerCase().includes(searchValue.toLowerCase())
      );
    }

    setFilteredVendor(filteredData);
  };

  const handleOpenDialog = () => {
    vendorModalRef.current.openDialog();
  };

  const handleCreateVendor = async (vall) => {
    let params = {
      name: vall?.name,
      email: vall?.email,
      phoneNumber: vall?.phone,
      referalCode: "",
      password: vall?.password,
      fcm: "",
      uniqueCode: "",
      role: "vendor",
      vendorShare: vall?.vendorShare,
      bbShare: vall?.bbShare,
      customerShare: vall?.customerShare,
    };
    console.log(params, "paramsparamsparams");
    try {
      setIsLoading(true);
      const response = await createVendor(params);
      setIsLoading(false);
      if (response?.status == 200 || response?.status == 201) {
        handleOpenSnackBar("success", response.data.message);
        handleFetchAllVendors();
        vendorModalRef.current.closeDialog();
      } else {
        handleOpenSnackBar("error", response.data.message);
      }
    } catch (error) {
      setIsLoading(false);
      console.log("🚀 ~ handleCreateVendor ~ error:", error);
    }
  };

  return (
    <NavigationDrawer>
      <CustomBar title={"VENDORS"} />

      <AppContainer>
        <Stack
          px={3}
          py={2}
          gap={2}
          direction={{ md: "row" }}
          alignItems={"center"}
        >
          <TextInput
            sx={{ flex: 1 }}
            placeholder={"Search Vendors"}
            InputStartIcon={<img src={APP_ICONS.searhIcon} width={20} />}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <Stack
            direction={{ sm: "row" }}
            width={"100%"}
            flex={2}
            gap={2}
            justifyContent={{ md: "flex-end" }}
          >
            <SelectInput
              placeholder={"Sort by status"}
              formStyleProps={selectInputWith}
              value={filterByStatus}
              onChange={(e) => setFilterByStatus(e.target.value)}
            >
              <MenuItem value={"All"}>All</MenuItem>
              <MenuItem value={"Active"}>Active</MenuItem>
              <MenuItem value={"InActive"}>InActive</MenuItem>
            </SelectInput>
            <CSVLink
              data={filteredVendor}
              headers={headersForCsv}
              filename="filtered-users.csv"
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              <Box
                height={40}
                bgcolor={"#003B95"}
                borderRadius={2}
                sx={{ width: { xs: "100%", md: 120 } }}
              >
                <Button>
                  <Typography color="#FFF">Export</Typography>
                </Button>
              </Box>
            </CSVLink>
            <Box
              onClick={handleOpenDialog}
              height={40}
              bgcolor={"#003B95"}
              borderRadius={2}
              sx={{ width: { xs: "100%", md: 120 } }}
            >
              <Button>
                <Typography color="#FFF">Add</Typography>
              </Button>
            </Box>
          </Stack>
        </Stack>
        <Divider />
        {filteredVendor?.length > 0 ? (
          <DynamicTable
            tableHeader={tableHeader}
            displayRows={displayRows}
            tableData={filteredVendor}
            showPagination={true}
            showVendorMenu={true}
            handleUpdateStatus={handleUpdateStatus}
          />
        ) : (
          <Typography
            color="black"
            fontSize={14}
            fontWeight={700}
            textAlign={"center"}
            padding={"30px 0"}
          >
            No Vendor Found!
          </Typography>
        )}
      </AppContainer>
      <Loader isloading={isLoading} />
      <CreateVendorModal
        ref={vendorModalRef}
        isLoading={isLoading}
        handleCreateVendor={handleCreateVendor}
      />
      {/* <OTPModal
        ref={codeModalRef}
        handleClickResend={handleCreateVendor}
        handleSubmitVendor={handleSubmitVendor}
      /> */}
    </NavigationDrawer>
  );
};

export default VendorsPage;
